import { Box, Flex, Icon, LinkBox, LinkOverlay, Text } from '@chakra-ui/react';
import { ElementType } from 'react';
import { Link } from 'react-router-dom';

export interface DataManagementItem {
  key: string;
  title: string;
  description: string;
  to: string;
  icon: ElementType;
}

interface Props {
  item: DataManagementItem;
}

// Mesmo visual do card de relatório, para as telas de "Gestão de dados" do
// SAMASC (não são relatórios do Power BI, por isso não têm favorito).
export function DataManagementCard({ item }: Props) {
  return (
    <LinkBox
      as="article"
      h="100%"
      bg="gray.800"
      borderWidth="1px"
      borderColor="gray.700"
      borderTopWidth="4px"
      borderTopColor="green.400"
      borderRadius="12px"
      boxShadow="sm"
      p="4"
      transition="all 0.3s"
      _hover={{ transform: 'translateY(-4px)', boxShadow: 'md' }}
      _active={{ transform: 'translateY(-1px)' }}
      _focusWithin={{ boxShadow: 'outline' }}
    >
      <Flex align="flex-start" gridGap="3">
        <Flex
          w="10"
          h="10"
          flexShrink={0}
          borderRadius="full"
          bg="green.100"
          color="green.600"
          align="center"
          justify="center"
        >
          <Icon as={item.icon} boxSize="5" />
        </Flex>

        <Box minW="0">
          <LinkOverlay as={Link} to={item.to} _focus={{ outline: 'none' }}>
            <Text fontWeight="medium" color="gray.50" noOfLines={2}>
              {item.title}
            </Text>
          </LinkOverlay>
          <Text fontSize="sm" color="gray.400" mt="1" noOfLines={2}>
            {item.description}
          </Text>
        </Box>
      </Flex>
    </LinkBox>
  );
}
